<template>
  <div>
    <div class="flex flex-wrap -mx-2">

      <!-- Selector de colaborador -->
      <div class="w-full mb-3 px-2">
        <wz-select-search
          label="Colaborador"
          required
          :items="employeeList"
          :value="form.employeeId"
          :disabled="lockEmployee"
          defaultOption="Buscar colaborador por nombre o documento"
          :error="v.employeeId.$error && !v.employeeId.required ? 'Colaborador es requerido' : ''"
          @change="onEmployeeChange"
        />
      </div>

      <!-- Info readonly del empleado seleccionado -->
      <template v-if="employeeInfo.fullName">
        <div class="w-full md:w-1/2 mb-3 px-2">
          <wz-select
            label="Tipo de documento"
            :items="identifierTypes"
            :value="employeeInfo.identifierType"
            defaultOption="—"
            :disabled="true"
          />
        </div>

        <div class="w-full md:w-1/2 mb-3 px-2">
          <wz-input
            label="Número de documento"
            :value="employeeInfo.identifier"
            :disabled="true"
          />
        </div>

        <div class="w-full mb-3 px-2">
          <wz-input
            label="Nombre completo"
            :value="employeeInfo.fullName"
            :disabled="true"
          />
        </div>
        <!-- Las alertas de contratos vigentes se muestran en ContractEditor (visibles en todos los tabs). -->
      </template>

      <!-- Tipo de contrato -->
      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-select
          label="Tipo de contrato"
          required
          v-model="form.contractType"
          :items="contractDurationList"
          defaultOption="Elegir tipo"
          :error="v.contractType.$error && !v.contractType.required ? 'Tipo de contrato es requerido' : ''"
        />
      </div>

      <!-- Duración en meses (solo contratos a plazo fijo) -->
      <div class="w-full md:w-1/2 mb-3 px-2" v-if="!isIndefinite">
        <wz-input
          label="Duración (meses)"
          type="number"
          min="1"
          v-model.number="form.durationMonths"
          placeholder="Ej: 6"
        />
      </div>

      <!-- Fecha de inicio (inmutable en edición: cambiarla desincroniza la antigüedad del período) -->
      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-datepicker
          label="Fecha de inicio"
          required
          v-model="form.startDate"
          :disabled="lockStartDate"
          :error="v.startDate.$error && !v.startDate.required ? 'Fecha de inicio es requerida' : ''"
        />
        <p v-if="lockStartDate" class="text-muted text-sm mt-1">
          <i class="ri-lock-line"></i>
          La fecha de inicio no se puede modificar después de crear el contrato.
          Si es incorrecta, anule el contrato y cree uno nuevo.
        </p>
      </div>

      <!-- Fecha de fin (se auto-calcula con la duración; editable manualmente; oculta si sin plazo fijo) -->
      <div class="w-full md:w-1/2 mb-3 px-2" v-if="!isIndefinite">
        <wz-datepicker
          label="Fecha de fin"
          v-model="form.finishDate"
        />
        <span v-if="durationError" class="wz-form-error-msg">
          <i class="ri-error-warning-line"></i>
          El plazo del contrato tipo {{ form.contractType }} supera el máximo legal de
          {{ durationMaxMonths }} meses según Art. 74 D.S. 003-97-TR.
        </span>
      </div>

      <!-- Fin período de prueba -->
      <div class="w-full md:w-1/2 mb-3 px-2">
        <wz-datepicker
          label="Fin período de prueba"
          v-model="form.probationEndDate"
        />
        <span v-if="probationExceedsLimit" class="wz-form-error-msg">
          <i class="ri-error-warning-line"></i>
          El período de prueba no puede exceder 6 meses desde la fecha de inicio
        </span>
      </div>

    </div>
  </div>
</template>

<script>
import * as moment from 'moment'
import { Constants } from '@/core/utils'

export default {
  props: {
    form:                 { type: Object, required: true },
    v:                    { type: Object, required: true },
    contractDurationList: { type: Array,  default: () => [] },
    employeeList:         { type: Array,  default: () => [] },
    employeeInfo:         { type: Object, default: () => ({
      identifierType: null,
      identifier: null,
      fullName: null,
      activeContracts: [],
    }) },
    isIndefinite:               { type: Boolean, default: false },
    lockEmployee:               { type: Boolean, default: false },
    lockStartDate:              { type: Boolean, default: false },
    durationError:              { type: Boolean, default: false },
    durationMaxMonths:          { type: Number,  default: null },
  },
  emits: ['employee-selected', 'probation-error'],
  data() {
    return {
      identifierTypes: [
        Constants.IdentifierType.DNI,
        Constants.IdentifierType.CE,
        Constants.IdentifierType.PASAPORTE,
        Constants.IdentifierType.LIBRETA_MILITAR,
        Constants.IdentifierType.CARNET_MILITAR,
      ],
    }
  },
  computed: {
    probationExceedsLimit() {
      if (!this.form.startDate || !this.form.probationEndDate) return false
      const maxDate = moment(this.form.startDate).add(6, 'months')
      return moment(this.form.probationEndDate).isAfter(maxDate)
    },
  },
  watch: {
    probationExceedsLimit(val) {
      this.$emit('probation-error', val)
    },
  },
  methods: {
    onEmployeeChange(id) {
      this.form.employeeId = id
      this.$emit('employee-selected', id)
    },
  },
}
</script>

<style lang="stylus" scoped></style>
